export const EDIT_DELIVERYS_SUCCEEDED = 'EDIT_DELIVERYS_SUCCEEDED';
export const EDIT_DELIVERYS_REQUESTED = 'EDIT_DELIVERYS_REQUESTED';

export const GET_DELIVERYS_REQUESTED = 'GET_DELIVERYS_REQUESTED';
export const GET_DELIVERYS_SUCCEEDED = 'GET_DELIVERYS_SUCCEEDED';

export const GET_DELIVERY_USER_DATA_REQUESTED = 'GET_DELIVERY_USER_DATA_REQUESTED';
export const GET_DELIVERY_USER_DATA_SUCCEEDED = 'GET_DELIVERY_USER_DATA_SUCCEEDED';
